import { Locale } from '@color/lib';
import { UseQueryOptions, keepPreviousData, useQuery } from '@tanstack/react-query';

import { DEFAULT_MESSAGES, getMessages } from './getMessages';

type HomeMessagesPayload = Record<string, string>;

export const useHomeMessagesQuery = (
  locale: Locale,
  options?: Omit<UseQueryOptions<HomeMessagesPayload, Error>, 'queryKey'>
) => {
  return useQuery<HomeMessagesPayload>({
    queryKey: [locale],
    queryFn: () => {
      return getMessages(locale);
    },
    ...options,
    initialData: DEFAULT_MESSAGES,
    placeholderData: keepPreviousData,
  });
};
